import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from './icon/icon.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { FaIconComponent } from './fa-icon/fa-icon.component';
import {
  faHome,
  faLink,
  faExternalLinkAlt,
  faAngleDoubleUp,
  faAngleDoubleRight,
  faEnvelope,
  faFileAlt,
  faUser,
  faUsers,
  faUserEdit,
  faUserTag,
  faUserCog,
  faPencilAlt,
  faTasks,
  faSignInAlt,
  faSignOutAlt,
  faQuestionCircle,
  faBook,
  faBookOpen,
  faInfoCircle,
  faBalanceScale,
  faShieldAlt,
  faCommentDots,
  faBug,
  faExclamation,
  faFolderOpen,
  faProjectDiagram,
  faChartBar,
  faPaintBrush,
  faList,
  faTable,
  faDownload,
  faUpload,
  faTerminal,
  faSearch,
  faFilter,
  faColumns,
  faSyncAlt,
  faBacterium,
  faDna,
  faCalculator,
  faCertificate,
  faCog,
  faCogs,
  faDatabase,
  faHashtag,
  faTag,
  faTags,
  faTachometerAlt,
  faCalendarAlt,
  faClock,
  faStopwatch,
  faCopy,
  faCode,
  faCodeBranch,
  faKeyboard,
  faDesktop,
  faQuestion,
  faUserCheck,
  faPlusCircle,
  faTools,
  faCheck,
  faTimes,
  faStar,
  faMedal,
  faCheckDouble,
  faLock,
  faLockOpen,
  faDollarSign,
  faSpinner,
  faFlask,
  faTrash,
  faChevronRight,
  faChevronDown,
  faCloud,
  faShareAlt,
  faLongArrowAltRight,
  faFilePdf,
  faVideo,
  faEye,
  faLocationArrow,
  faMicrochip,
  faSave,
  faMemory,
  faServer,
  faWaveSquare,
  faSquareRootAlt,
  faRedoAlt,
  faBackward,
  faForward,
  faExchangeAlt,
  faBullhorn,
  faSlidersH,
  faFileArchive,
  faImage,
  faLightbulb,
} from '@fortawesome/free-solid-svg-icons';
import {
  faGitAlt,
  faGithub,
  faDocker,
  faPython,
  faLinkedin,
  faFacebook,
  faTwitter,
  faOrcid,
  faCreativeCommons,
  faCreativeCommonsBy,
  faCreativeCommonsNc,
  faCreativeCommonsZero,
  faCreativeCommonsSa,
  faCreativeCommonsShare,
  faOsi,
  faGoogleDrive,
  faYoutube,
  faUncharted,
  faRProject,
  faJava,
  faJs,
  faPhp,
  faCss3,
  faHtml5,
} from '@fortawesome/free-brands-svg-icons';
import { faFileAlt as farFileAlt, faStar as farStar } from '@fortawesome/free-regular-svg-icons';
import { MatIconComponent } from './mat-icon/mat-icon.component';
import { CCIconComponent } from './cc-icon/cc-icon.component';
export { BiosimulationsIcon } from './icon/icon.component';
@NgModule({
  imports: [CommonModule, MatIconModule, FontAwesomeModule, MatSnackBarModule],
  declarations: [IconComponent, FaIconComponent, MatIconComponent, CCIconComponent],
  exports: [IconComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class BiosimulationsIconsModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faShareAlt,
      faHome,
      faLink,
      faExternalLinkAlt,
      faAngleDoubleUp,
      faAngleDoubleRight,
      faEnvelope,
      faFileAlt,
      faUser,
      faUsers,
      faUserEdit,
      faUserTag,
      faUserCheck,
      faUserCog,
      faPencilAlt,
      faTasks,
      faSignInAlt,
      faSignOutAlt,
      faQuestionCircle,
      faBook,
      faBookOpen,
      faInfoCircle,
      faCloud,
      faBalanceScale,
      faShieldAlt,
      faCommentDots,
      faBug,
      faExclamation,
      faFolderOpen,
      faProjectDiagram,
      faChartBar,
      faUncharted,
      faRProject,
      faJava,
      faJs,
      faPhp,
      faCss3,
      faHtml5,
      faUncharted,
      faPaintBrush,
      faList,
      faPlusCircle,
      faTools,
      faCheck,
      faTimes,
      faStar,
      faCertificate,
      faMedal,
      faCheckDouble,
      faLock,
      faLockOpen,
      faDollarSign,
      faSpinner,
      faFlask,
      faTrash,
      faChevronRight,
      faChevronDown,
      faTable,
      faDownload,
      faUpload,
      faTerminal,
      faSearch,
      faFilter,
      faColumns,
      faSyncAlt,
      faBacterium,
      faDna,
      faCalculator,
      faCog,
      faCogs,
      faDatabase,
      faHashtag,
      faTag,
      faTags,
      faTachometerAlt,
      faCalendarAlt,
      faClock,
      faStopwatch,
      faCopy,
      faCode,
      faCodeBranch,
      faKeyboard,
      faDesktop,
      faGitAlt,
      faQuestion,
      faGithub,
      faDocker,
      faPython,
      faLinkedin,
      faFacebook,
      faTwitter,
      faOrcid,
      faCreativeCommons,
      faCreativeCommonsBy,
      faCreativeCommonsNc,
      faCreativeCommonsZero,
      faCreativeCommonsSa,
      faCreativeCommonsShare,
      farFileAlt,
      farStar,
      faOsi,
      faLongArrowAltRight,
      faFilePdf,
      faVideo,
      faEye,
      faLocationArrow,
      faMicrochip,
      faSave,
      faMemory,
      faServer,
      faGoogleDrive,
      faYoutube,
      faWaveSquare,
      faSquareRootAlt,
      faRedoAlt,
      faBackward,
      faForward,
      faExchangeAlt,
      faBullhorn,
      faSlidersH,
      faFileArchive,
      faImage,
      faLightbulb,
    );
  }
}
